var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#413C6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9603 10.6667C16.6003 10.6667 10.627 16.6401 10.627 24.0001C10.627 31.3601 16.6003 37.3334 23.9603 37.3334C31.3203 37.3334 37.2936 31.3601 37.2936 24.0001C37.2936 16.6401 31.3336 10.6667 23.9603 10.6667ZM24.0003 29.6401C20.8803 29.6401 18.3603 27.1201 18.3603 24.0001C18.3603 20.8801 20.8803 18.3601 24.0003 18.3601C27.1203 18.3601 29.6403 20.8801 29.6403 24.0001C29.6403 27.1201 27.1203 29.6401 24.0003 29.6401Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleRecord);
export default __webpack_public_path__ + "static/media/simpleRecord.f730ab190156aaaa7219d7eecef33633.svg";
export { ForwardRef as ReactComponent };